import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import { CirclePicker } from "react-color";
import Box from "@mui/material/Box";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
import classNames from "classnames";
// config

// useStyle
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

//
const ColorPickerBasic = ({ className, ...rest }) => {
  // style
  const classes = useStyles();
  // props

  // local state

  //
  return (
    <Box
      px={2}
      py={2}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <CirclePicker
        className={classNames("color-picker", className)}
        width="120px"
        circleSize={16}
        circleSpacing={8}
        {...rest}
      />
    </Box>
  );
};

ColorPickerBasic.propTypes = {
  className: PropTypes.string,
};

ColorPickerBasic.defaultProps = {
  className: "color-picker",
};

export default ColorPickerBasic;
